import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import type { RootState } from '@/redux/store/configureStore'

export type StatsigClientValues = {
    bootstrapValues: string | null
    stableID: string
    clientKey: string
}

export interface StatsigState {
    statsigClientValues: StatsigClientValues | null
    experiments: Record<string, string>
}

const initialState: StatsigState = {
    statsigClientValues: null,
    experiments: {}
}

const statsigSlice = createSlice({
    name: 'statsig',
    initialState,
    reducers: {
        setStatsigClientValues: (state, action: PayloadAction<StatsigClientValues>) => {
            state.statsigClientValues = action.payload
        },
        setExperiment: (state, action: PayloadAction<{ name: string; value: string }>) => {
            state.experiments[action.payload.name] = action.payload.value
        },
        setMultipleExperiments: (state, action: PayloadAction<Record<string, string>>) => {
            state.experiments = { ...state.experiments, ...action.payload }
        }
    }
})

export const { setStatsigClientValues, setExperiment, setMultipleExperiments } = statsigSlice.actions

// Selectors
export const selectStatsigClientValues = (state: RootState) => state.statsig?.statsigClientValues
export const selectExperiments = (state: RootState) => state.statsig?.experiments || {}
export const selectExperiment = (experimentName: string) => (state: RootState) =>
    state.statsig?.experiments?.[experimentName] || ''

export default statsigSlice.reducer
